import React from 'react'
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import "./Home.css"
import About from '../About/About';
import Whatweoffer from './Whatweoffer';

const Home = () => {

    function scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    }
    return (
        <div className="home">
            <Carousel infiniteLoop={true} showArrows={false} showThumbs={false} autoPlay={true} useKeyboardArrows={true} showStatus={false} >
                <div className="carousel">
                    <div className="home__left carousel__a">
                        <p className='home__left_p'>"I built myself up from scratch;<br></br> Now it's your turn."</p>
                    </div>

                </div>
                <div className="carousel carousel__b ">
                    <div className="home__left carousel__a">
                        <p className='home__left_p'>"Where there's a will, there's a way.<br></br> Otherwise, there's just excuses."</p>
                    </div>

                </div>
                <div className="carousel carousel__c">
                    <div className="home__left carousel__a">
                        <p className='home__left_p'>"Strength comes from indomitable will, <br></br> not physical capacity." </p>
                    </div>
                </div>
            </Carousel>

            <Whatweoffer />
            <About />

        
        </div>
    )
}


export default Home